import { render, staticRenderFns } from "./Constancias.vue?vue&type=template&id=38c46a8a&"
import script from "./Constancias.vue?vue&type=script&lang=js&"
export * from "./Constancias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports